// @flow
import * as React from 'react'
import moment from 'moment-timezone'
import type { Coordinates, Gathering, School } from 'types'
import type { AsyncResource } from 'framework'
import { MutedText, P } from 'ui/Typography'
import Grid, { GridCell } from 'ui/Grid'
import HR from 'ui/HR'
import TabBar from 'ui/TabBar'
import RelatedPrograms from '../shared/RelatedPrograms'
import RailSection from '../shared/RailSection'
import GatheringPageBigDate from './BigDate'
import GatheringPageContent from './Content'
import GatheringPageInfo from './Info'
import GatheringPageMap from './Map'

type Tab = 'About' | 'Location'
const TABS: Tab[] = ['About', 'Location']
const TAB_ABOUT: Tab = 'About'
const TAB_LOCATION: Tab = 'Location'

type Props = {
  gathering: Gathering,
  coordinates: AsyncResource<Coordinates>,
  school: School,
}

type State = {
  currentTab: Tab,
}

declare var ENV: any

export default class GatheringPageMobileContent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      currentTab: TAB_ABOUT,
    }
  }

  render = () => {
    return (
      <div>
        {this.renderDate()}
        {this.renderTabBar()}

        <div className="GatheringPage-content">
          {this.renderAboutMaybe()}
          {this.renderLocationMaybe()}
          <HR />
          {this.renderRelatedSchoolListings()}
        </div>
      </div>
    )
  }

  renderDate = () => {
    return (
      <div className="GatheringPage-bigDateContainer">
        <div className="GatheringPage-content">
          <Grid justifyContent="space-between" alignItems="center">
            <GridCell flex="none">
              <GatheringPageBigDate {...this.props} />
            </GridCell>
            <GridCell flex="none">
              <MutedText>
                {this.formatBeginsAt('h:mma')}-{this.formatEndsAt('h:mma')}
              </MutedText>
            </GridCell>
          </Grid>
        </div>
      </div>
    )
  }

  renderTabBar = () => {
    return (
      <TabBar
        tabs={(TABS: any)}
        currentTab={`${this.state.currentTab}`}
        onChange={this.handleTabChange}
      />
    )
  }

  renderAboutMaybe = () => {
    if (this.state.currentTab !== TAB_ABOUT) return null

    return <GatheringPageContent {...this.props} />
  }

  renderLocationMaybe = () => {
    if (this.state.currentTab !== TAB_LOCATION) return null

    return (
      <React.Fragment>
        <P>
          <GatheringPageMap coordinates={this.props.coordinates} />
        </P>
        <P>
          <GatheringPageInfo {...this.props} />
        </P>
      </React.Fragment>
    )
  }

  renderRelatedSchoolListings = () => {
    return (
      <div className="GatheringPage-relatedSchools">
        <RailSection title="Related Programs">
          <RelatedPrograms school={this.props.school} />
        </RailSection>
      </div>
    )
  }

  handleTabChange = (currentTab: any) => {
    this.setState({ currentTab })
  }

  formatBeginsAt = (format: string): string => {
    return moment(this.props.gathering.beginsAt).tz(this.props.school.timezone).format(format)
  }

  formatEndsAt = (format: string): string => {
    return moment(this.props.gathering.endsAt).tz(this.props.school.timezone).format(format)
  }
}
